import {AttributeType} from '@netx/core-attribute/constants';

export enum AttributeVocabularyPref {
	ENABLED = 'metadata.vocabulary.enabled',
}

export const ATTRIBUTE_VOCABULARY_TYPES: readonly AttributeType[] = [
	AttributeType.SELECT,
	AttributeType.MULTISELECT,
	// AttributeType.TAG,
	AttributeType.TAG_VOCAB,
];
